import React, { FC } from 'react';

import getClassNames from 'src/common/utils/getClassNames';

import classNames from 'classnames';
import styles from './Modal.module.scss';

type FooterProps = {
  /**
   * The main action button for proceeding through modal.
   */
  buttonPrimary: React.ReactNode;
  /**
   * Any secondary action button. Optional.
   * Will sit above primary on small screens and to the left of primary on large screens.
   */
  buttonSecondary?: React.ReactNode;
  /**
   * Optional content, useful for warnings.
   * Will sit above button section when present.
   */
  slot?: React.ReactNode;
  buttonDirection?: 'row' | 'column' | 'columnReverse';
  fullWidth?: boolean;
  withTopSpacing?: boolean;
};

const Footer: FC<FooterProps> = ({
  buttonPrimary,
  buttonSecondary,
  slot,
  buttonDirection = 'row',
  fullWidth = false,
  withTopSpacing = false,
}) => (
  <footer className={styles.footer}>
    {slot && <div className={styles.slotFooter}>{slot}</div>}
    <div className={getClassNames(styles, 'buttonGroup', classNames(buttonDirection, { fullWidth, withTopSpacing }))}>
      {buttonSecondary && <div className={getClassNames(styles, 'buttonFooter', buttonDirection)}>{buttonSecondary}</div>}
      <div className={styles.buttonFooter}>{buttonPrimary}</div>
    </div>
  </footer>
);

export default Footer;
